// External libraries
import React from 'react';
import { func } from 'prop-types';
import { useStoreState } from 'easy-peasy';
import { FloatingLabelSelect } from '@checkout/react-components';

// Internal modules
import { features, getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';

const SecondaryIdentityDocumentType = props => {
  useMountLogging('SecondaryIdentityDocumentType');
  const secondaryIdentityDocumentType = useStoreState(
    ({ form }) => form.secondaryIdentityDocumentType,
  );
  // eslint-disable-next-line max-len
  const secondaryIdentityDocumentTypeOptions = features.config.secondaryKycIdTypes.map(
    type => {
      return {
        text: getContent(`fieldValues.${type}`),
        value: type,
      };
    },
  );

  return (
    <FloatingLabelSelect
      blurHandler={props.blurHandler}
      changeHandler={props.changeHandler}
      focusHandler={props.focusHandler}
      id="secondaryIdentityDocumentType"
      label={getContent('fieldLabels.secondaryIdentityDocumentType')}
      required={true}
      selectOptions={secondaryIdentityDocumentTypeOptions}
      {...secondaryIdentityDocumentType}
    />
  );
};

SecondaryIdentityDocumentType.propTypes = {
  blurHandler: func,
  changeHandler: func.isRequired,
  focusHandler: func,
};

export { SecondaryIdentityDocumentType };
